// extracted by mini-css-extract-plugin
module.exports = {"disclaimerBox":"disclaimerBox___3yNl3","infoIconButton":"infoIconButton___p6WWk","infoIcon":"infoIcon___1bvu5"};